import * as priority from 'priority-web-sdk';
import {Configuration, ProcData, ProcType} from 'priority-web-sdk';
import {API_BASE_URL} from '../../../services/proto/core/server';
import {getTabulaIni, getUserLogin, getUserPassword} from '../../../constants/metaData';
import {getLang} from '../../../Localization';
import {getCompanyName} from '../../../utils/proto-api-utils/utils';
import {appName, isOpenidLogin} from '../../../services/proto/core/loginProps';
import {getKey} from '../../../services/wasm/apiService';
import {noop} from '@priority-software/priority-style-react/dist';
import {getWcfLogin} from '../../../_shared/GWTBridge/invoke/genPage';

const getLoginConfig: () => Configuration = () => ({
    url: API_BASE_URL,
    tabulaini: getTabulaIni(),
    language: Number(getLang()),
    profile: {company: getCompanyName()},
    username: isOpenidLogin() ? getWcfLogin() : getUserLogin(),
    password: getUserPassword(),
    appid: appName,
    appname: appName,
    appkey: getKey(),
    devicename: ''
});

const userLogin = async () => {
    try {
        await priority.login(getLoginConfig());
    } catch (e) {
        throw Error(e as string);
    }
};

export const startProcedure = async (procName: string, type: ProcType): Promise<ProcData> => {
    await userLogin();
    return await priority.procStart(procName, type, noop, getCompanyName());
};
